
/*
FormTime is a vue2-timepicker.
Parent components can syncronize their time fields with FormTime as follows:

            <FormTime
              :label="field label"
              v-model="parentTime"
            />
*/

import VueTimepicker from 'vue2-timepicker'
import 'vue2-timepicker/dist/VueTimepicker.css'

import styled from 'vue-styled-components'
import validationMixin from '../utils/validationMixin'
import textFieldMixin from '@/agilis/components/Form/utils/textFieldMixin.js'

const TimePickerWrapper = styled.div`
  position: relative;

  /* Override CSS of vue2-timepicker:*/
  .vue__time-picker {
    input {
      visibility: hidden; /* hide the input */
    }

    .select-list { /* box shadow for consistency with vuetify UIEs */
        box-shadow: 0 5px 5px -3px rgba(0,0,0,.2),
          0 8px 10px 1px rgba(0,0,0,.14),
          0 3px 14px 2px rgba(0,0,0,.12);

        ul li:not([disabled]).active {
          background-color: var(--v-primary-base);  /* active background color consistent with app primary color */
        }
    }
  }
`

export default {
  name: 'FormTime',
  mixins: [validationMixin, textFieldMixin],

  props: {
    value: String,
    required: Boolean
  },

  components: {
    VueTimepicker,
    TimePickerWrapper
  },

  data: () => ({
    time: null
  }),

  created () {
    this.time = this.value || this.defaultValue

    this.$emit('input', this.time)
  },

  methods: {
    handleTimePickerInput (item, event) {
      const vv = item.split(':')
      const HH = (vv[0] && vv[0] !== 'HH') ? vv[0] : '00'
      const mm = (vv[1] && vv[1] !== 'mm') ? vv[1] : '00'
      const ss = (vv[2] && vv[2] !== 'ss') ? vv[2] : '00'

      // update parent with current value with placeholders replaced with 00
      this.$emit('input', `${HH}:${mm}:${ss}`)
    },
    clearValue () {
      this.time = null
      this.$emit('input', this.time)
    },
    forwardFocus () {
      // Forward focus from label to timepicker
      this.$refs.timepicker.onFocus()
    }
  }
}
